// extracted by mini-css-extract-plugin
export default {"container":"YGYs12eEZ0SXmsl7mA2K"};